import React from 'react'
import "./Promo.css";
import { Col, Container, Row } from 'react-bootstrap'
import BenIcon1 from '../../Images/4icon1.png'
import BenIcon2 from '../../Images/4icon2.png'
import BenIcon3 from '../../Images/4icon3.png'
import BenIcon4 from '../../Images/4icon4.png'
import Downredarrow from '../../Images/down-red-arrow.png'

const Benefits = () => {
  return (
    <>
        <div className='benefitsbox'>
            <Container className='benefitsmain'>
                <Row>
                    <Col md={3} className='benmain'>
                        <img src={BenIcon1}/>
                    </Col>
                    <Col md={3} className='benmain'>
                        <img src={BenIcon2}/>
                    </Col>
                    <Col md={3} className='benmain'>
                        <img src={BenIcon3}/>
                    </Col>
                    <Col md={3} className='benmain'>
                        <img src={BenIcon4}/>
                    </Col>
                </Row>
            </Container>
            <Container className='benefitsmain'>
                <Row>
                    <Col md={3} className='benmain'>
                        <p>Free worldwide shipping on orders over INR 499</p>
                    </Col>
                    <Col md={3} className='benmain'>
                        <p>24/7 customer support</p>
                    </Col>
                    <Col md={3} className='benmain'>
                        <p>Your information is safe with BB</p>
                    </Col>
                    <Col md={3} className='benmain'>
                        <p>Money back promise</p>
                    </Col>
                </Row>
            </Container>

            <div className='bigredarrowmain'>
                <h2 className='ditch'>Ditch the Paper, Go Digital! – Now for just</h2>
                <img src={Downredarrow} className='downred'/>
            </div>
        </div>
    </>
  )
}

export default Benefits